import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=1b4a0968&scoped=true&lang=pug"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a0968",
  null
  
)

export default component.exports